<div class="scene-editor-shell">
    @if (displayBreadcrumbs.length > 0) {
        <div class="scene-breadcrumbs-bar">
            <button class="breadcrumb-home" (click)="goHome()"
                    matTooltip="{{'navigation.exitScene' | transloco}}">
                <mat-icon>home</mat-icon>
            </button>
            <button class="breadcrumb-back" (click)="goBack()"
                    [disabled]="!canGoBack"
                    matTooltip="{{'general.back' | transloco}}">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <button class="breadcrumb-drill-in" (click)="drillIn()"
                    [disabled]="!canDrillIn"
                    matTooltip="{{'navigation.drillIn' | transloco}}">
                <mat-icon>login</mat-icon>
            </button>
            <div class="breadcrumbs-container">
                @for (crumb of displayBreadcrumbs; track crumb.sceneId + ':' + (crumb.sceneItemId || ''); let i = $index; let first = $first; let last = $last) {
                    <span class="breadcrumb-item"
                          [class.active]="last"
                          [class.first]="first"
                          [class.last]="last"
                          [class.clickable]="!last"
                          [matTooltip]="crumb.label"
                          [matTooltipDisabled]="!crumbTruncated(crumb.label)"
                          (click)="!last && navigateToBreadcrumb(i)">
                        {{ crumbLabel(crumb.label) }}
                    </span>
                }
            </div>
            <!-- Preview + register-player actions, pinned to the right of the breadcrumb bar. Declared in
                 scene-builder (keeps their handlers) and published through ContainerService. -->
            @if (containerService.breadcrumbActionsTemplate | async; as actionsTpl) {
                <div class="breadcrumb-actions-slot">
                    <ng-container [ngTemplateOutlet]="actionsTpl"></ng-container>
                </div>
            }
        </div>
    }
    <!-- Editor toolbar, relocated here from inside scene-builder: a full-width bar directly under the
         breadcrumb. The template is declared in scene-builder (keeping all its action bindings) and published
         through ContainerService; it is null in non-scene modes, so the bar only shows for the canvas editor. -->
    @if (containerService.toolbarTemplate | async; as toolbarTpl) {
        <ng-container [ngTemplateOutlet]="toolbarTpl"></ng-container>
    }
    <div class="scene-editor-body">
<mat-drawer-container class="scene-editor-container">
  <mat-drawer #toolboxDrawer mode="side" position="start" [opened]="!componentMode || componentEditNeedsToolbox" [disableClose]="true">
    <app-scene-nav (whenMinimized)="onNavMinimized($event);" (whenMaximized)="onNavMaximized()"></app-scene-nav>
  </mat-drawer>
  <mat-drawer-content>
    @if (renderSceneContainer) {
      <div fxLayout="row" class="list-container main-container" fxFlex="100%">
        @if (viewMode !== 'collectionMode' &&
          viewMode !== 'playlistMode' &&
          viewMode !== 'locationMode' &&
          viewMode !== 'animationMode') {
          <div class="sceneSubContainer">
            <app-scene-builder #sceneBuilder
              (toggleMinimize)="toggleMinimize()"
              [setSceneData]="sceneData"
              [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
              [setSelectedSceneItemId]="selectedSceneItemId"
              [setSelectedSceneIdDataChanged]="sceneSlice"
              [isDrilledIn]="displayBreadcrumbs.length > 1"
              [setSelectedSceneId]="selectedSceneId">
            </app-scene-builder>
          </div>
        }
        @switch (viewMode) {
          @case ('playlistMode') {
            <div class="playlist-wrapper">
              <app-playlist-editor
                [mode]="'playlistMode'"
                [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
                (toggleMinimize)="toggleMinimize()">
              </app-playlist-editor>
            </div>
          }
          @case ('collectionMode') {
            <div class="playlist-wrapper">
              <app-playlist-editor
                [mode]="'collectionMode'"
                [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
                (toggleMinimize)="toggleMinimize()">
              </app-playlist-editor>
            </div>
          }
          @case ('locationMode') {
            <div class="list-container main-container location-wrapper">
              <app-location-based
                [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
                (toggleMinimize)="toggleMinimize()">
              </app-location-based>
            </div>
          }
        }
      </div>
    }
    @if (!renderSceneContainer) {
      <div class="loading-scene">
        <app-loading [type]="-1" [size]="'50px'"></app-loading>
      </div>
    }
  </mat-drawer-content>



  <mat-drawer [opened]="sidenavOpened" [mode]="sidenavMode" position="end" #sidenav disableClose>
    <div class="list-container scenePropsContainer" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center" class="side-main-menu">
        @if (!minimized) {
          <span class="drawerHeader" style="padding-top: 4px;">{{ 'general.properties' | transloco }}</span>
          <mat-icon (click)="onMinimized()" style="position: absolute; left: 10px; top: 4px; cursor: pointer">keyboard_double_arrow_right</mat-icon>
        }
        @if (minimized) {
          <mat-icon (click)="onMaximized()" style="position: absolute; left: 10px; top: 4px; cursor: pointer">keyboard_double_arrow_left</mat-icon>
        }
      </div>




      <mat-drawer-container class="drawer-container" style="height: 100%">
        <mat-drawer mode="side" position="end" opened style="width: 72px">
          <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'details'}" (click)="setActiveTemplate('details')">
            <fa-icon size="xl" class="faNav" [icon]="faWrench"></fa-icon>
            {{ 'general.details' | transloco }}
          </div>
          @if (isBlockAnimation && isNotNested && renderSceneContainer && !multiple) {
            <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'animation'}" (click)="setActiveTemplate('animation')">
              <mat-icon style="margin-left: 5px; font-size: 24px;">flare</mat-icon>
              {{ 'general.animation' | transloco }}
            </div>
          }
          @if (isNotNested && renderSceneContainer && !multiple) {
            @if (showEffects) {
              <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'effects'}" (click)="setActiveTemplate('effects')">
                <mat-icon style="margin-left: 5px; font-size: 24px;">blur_on</mat-icon>
                {{ 'general.effects' | transloco }}
              </div>
            }
          }
        </mat-drawer>
        <mat-drawer-content [style.width.px]="minimized ? 0 : 265">
          <div class="propertyPanel" >
            <ng-container *ngTemplateOutlet="getTemplate(activeTemplate)"></ng-container>
            <ng-template #detailsTemplate>
              <mat-accordion [multi]="false" class="accordion-container">
                <mat-expansion-panel #propPanel portalHandler [expanded]="false" (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false" class="scrollable-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (blockIcon) {
                        <fa-icon class="faIconPosition" size="lg" [icon]="blockIcon"></fa-icon>
                      }
                      <span class="accordionIcons">{{ multiple ? ('ai.multiSelection' | transloco) : blockMimeName }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                    @if (propPanel.expanded) {
                      <app-video-link style="position: absolute; right: 40px; top: 15px" [videoLink]="'/help/'+blockVideoLinkName"></app-video-link>
                    }

                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    @if (multiple) {
                      <div class="selected-items-list">
                        <div class="selected-items-header-row">
                          <div class="selected-items-header">{{ 'ai.selectedItems' | transloco }}</div>
                          <button mat-icon-button class="deselect-all-btn" (click)="deselectAll()" matTooltip="{{ 'ai.deselectAll' | transloco }}">
                            <mat-icon>clear_all</mat-icon>
                          </button>
                        </div>
                        @for (item of getSelectedItems(); track item.id) {
                          <div class="selected-item">
                            <div class="item-icon">
                              <fa-icon [icon]="item.icon"></fa-icon>
                            </div>
                            <span class="item-name">{{item.name}}</span>
                          </div>
                        }
                      </div>
                    } @else {
                      <div [@fadeProperty]="visibility" (@fadeProperty.done)="animationDone($event)">
                        <app-block-loader></app-block-loader>
                      </div>
                    }
                    @if (!accessConfig?.upd) {
                      <div class="only-view"></div>
                    }
                  </ng-template>
                </mat-expansion-panel>
                @if (!multiple && isDataProvider) {
                  <mat-expansion-panel portalHandler class="scrollable-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <fa-icon size="lg" class="faIconPosition" [icon]="faHdd"></fa-icon>
                        <span class="accordionIcons">
                          data provider
                        </span>
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <app-block-data-provider></app-block-data-provider>
                    </ng-template>
                    @if (!accessConfig?.upd) {
                      <div class="only-view"></div>
                    }
                  </mat-expansion-panel>
                }

                @if (!multiple && blockName === 'scene' && isPlayerAssignable && experienceLevel > experienceLevelType.BEGINNER) {
                  <mat-expansion-panel portalHandler class="scrollable-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <fa-icon size="lg" [icon]="faPlugCircleCheck"></fa-icon>
                        <span class="accordionIcons">{{ 'general.playerConfig' | transloco }}</span>
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <app-block-scene [sceneTopProps]="true"></app-block-scene>
                    </ng-template>
                    @if (!accessConfig?.upd) {
                      <div class="only-view"></div>
                    }
                  </mat-expansion-panel>
                }

                @if (!multiple && isBlockBeacon) {
                  <mat-expansion-panel portalHandler class="scrollable-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-icon style="margin-right: 8px; color: #2196F3;">palette</mat-icon>
                        <span class="accordionIcons">styles</span>
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <app-scene-block-beacon-style></app-scene-block-beacon-style>
                      @if (!accessConfig?.upd) {
                        <div class="only-view"></div>
                      }
                    </ng-template>
                  </mat-expansion-panel>
                }

                @if (!multiple && selectedItemHasLayout && (!componentMode || groupEditMode)) {
                  <mat-expansion-panel portalHandler #layoutPanel class="scrollable-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <fa-icon size="lg" class="faIconPosition" [icon]="faObjectUngroup"></fa-icon>
                        <span class="accordionIcons">{{ 'general.layout' | transloco }}</span>
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>

                      @if (layoutPanel.expanded && experienceLevel > experienceLevelType.BEGINNER) {
                        <app-video-link style="position: absolute; right: 40px; top: 15px" videoLink="layout"></app-video-link>
                      }

                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <app-block-layout-common-props></app-block-layout-common-props>
                      @if (!accessConfig?.upd) {
                        <div class="only-view"></div>
                      }
                    </ng-template>
                  </mat-expansion-panel>
                }

                @if (!multiple && isBlockCollection && !isCollectionSlideshow) {
                  <mat-expansion-panel portalHandler class="scrollable-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <fa-icon size="lg" class="faIconPosition" [icon]="faHandPointer"></fa-icon>
                        <span class="accordionIcons">{{ 'general.touch' | transloco }}</span>
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <app-block-collection-touch></app-block-collection-touch>
                      @if (!accessConfig?.upd) {
                        <div class="only-view"></div>
                      }
                    </ng-template>
                  </mat-expansion-panel>
                }
                <!-- removed anchor support 9-21-2023 -->
                <!--                        <mat-expansion-panel portalHandler *ngIf="isHostDevOrLocal && isAnchorSupport">-->
                <!--                            <mat-expansion-panel-header>-->
                <!--                                <mat-panel-title>-->
                <!--                                    <fa-icon size="lg" [icon]="faAnchor"></fa-icon>-->
                <!--                                    <span class="accordionIcons">{{'general.anchor' | transloco}}</span>-->
              <!--                                </mat-panel-title>-->
              <!--                                <mat-panel-description>-->
            <!--                                </mat-panel-description>-->
          <!--                            </mat-expansion-panel-header>-->
          <!--                            <ng-template matExpansionPanelContent>-->
          <!--                                <app-anchor></app-anchor>-->
        <!--                            </ng-template>-->
        <!--                            <div class="only-view" *ngIf="!accessConfig?.upd"></div>-->
      <!--                        </mat-expansion-panel>-->
      @if (!multiple && showEvents && !isCollectionSlideshow && experienceLevel == experienceLevelType.ADVANCED) {
        <mat-expansion-panel #eventPanel portalHandler class="scrollable-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <fa-icon size="lg" class="faNav" [icon]="faBell"></fa-icon>
              <span class="accordionIcons">{{ 'general.events' | transloco }}</span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
            @if (eventPanel.expanded) {
              <app-video-link style="position: absolute; right: 40px; top: 15px" videoLink="Button"></app-video-link>
            }
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if (eventsLocked) {
              <button (click)="upgradeEvents()" mat-raised-button color="warn">
                {{ 'general.upgUseFeature' | transloco }}
              </button>
              <br/><br/>
            }
            <div [class.events-locked]="eventsLocked">
              <mat-tab-group [@.disabled]="true" tabGroupDrag mat-stretch-tabs="false" mat-align-tabs="start">
                @if (isBlockAdvEvents?.send) {
                  <mat-tab label="{{'general.sendEvents' | transloco}}">
                    <app-block-send-events></app-block-send-events>
                  </mat-tab>
                }
                @if (isBlockAdvEvents?.receive) {
                  <mat-tab
                    label="{{'general.receiveEvents' | transloco}}">
                    <app-block-receive-events></app-block-receive-events>
                  </mat-tab>
                }
                @if (isBlockAdvEvents?.source) {
                  <mat-tab
                    label="{{'general.eventSource' | transloco}}">
                    <app-block-event-source></app-block-event-source>
                  </mat-tab>
                }
                @if (isBlockAdvEvents?.filter) {
                  <mat-tab label="{{'general.filters' | transloco}}">
                    <app-block-filter-events></app-block-filter-events>
                  </mat-tab>
                }
              </mat-tab-group>
            </div>
          </ng-template>
          @if (!accessConfig?.upd) {
            <div class="only-view"></div>
          }
        </mat-expansion-panel>
      }
      @if (!multiple && showPop && !isCollectionSlideshow && experienceLevel == experienceLevelType.ADVANCED) {
        <mat-expansion-panel #popPanel portalHandler class="scrollable-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <fa-icon size="lg" class="faNav" [icon]="faReceipt"></fa-icon>
              <span class="accordionIcons">{{ 'general.proofOfPlay' | transloco }}</span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
            @if (popPanel.expanded) {
              <app-video-link style="position: absolute; right: 40px; top: 15px" videoLink="sign_pop"></app-video-link>
            }
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <app-block-pop></app-block-pop>
          </ng-template>
          @if (!accessConfig?.upd) {
            <div class="only-view"></div>
          }
        </mat-expansion-panel>
      }
      @if (!multiple && renderSceneContainer && isSceneButNotNested && experienceLevel == experienceLevelType.ADVANCED && iotEnabled === '1') {
        <mat-expansion-panel portalHandler class="scrollable-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <fa-icon size="lg" class="faNav" [icon]="faRandom"></fa-icon>
              <span class="accordionIcons">event rules</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <app-button-bar [items]="eventRulesHighlightedRows" [setButtons]="eventRulesButtons" (buttonEmit)="$event.name === 'add' ? addEventRule() : removeSelectedEventRule()"></app-button-bar>
            <table mat-table [dataSource]="eventRulesDataSource" class="mat-elevation-z8 matTableMaxSpace" style="width: 100%">
              <ng-container matColumnDef="eventName">
                <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>event</th>
                <td mat-cell class="textAlignLeft" *matCellDef="let element; let i = index">
                  <span style="font-size: 12px">
                    {{ element.$.eventName || '...' }}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="expression">
                <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>expression</th>
                <td mat-cell class="textAlignLeft" *matCellDef="let element; let i = index">
                  <span style="font-size: 11px; opacity: 0.8">
                    {{ element.$.expression || '...' }}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef style="width: 22px; padding: 0"></th>
                <td mat-cell *matCellDef="let element; let i = index" style="padding: 0; text-align: center">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px; cursor: pointer"
                    [style.color]="selectedEventRuleIndex === i ? '#fff' : '#4caf50'" (click)="editEventRuleExpression(i)">edit</mat-icon>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['eventName', 'expression', 'edit']"></tr>
              <tr mat-row *matRowDef="let row; let i = index; columns: ['eventName', 'expression', 'edit']"
                  [style.background]="selectedEventRuleIndex === i ? 'var(--background-default2)' : ''"
                  (click)="selectEventRule(i)" (dblclick)="editEventRuleExpression(i)"></tr>
            </table>
            @if (!accessConfig?.upd) {
              <div class="only-view"></div>
            }
          </ng-template>
        </mat-expansion-panel>
      }
      @if (!multiple && renderSceneContainer && isSceneButNotNested && experienceLevel == experienceLevelType.ADVANCED && iotEnabled === '1') {
        <mat-expansion-panel portalHandler class="scrollable-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <fa-icon size="lg" class="faNav" [icon]="faBolt"></fa-icon>
              <span class="accordionIcons">init events</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <app-button-bar [items]="initEventsHighlightedRows" [setButtons]="initEventsButtons" (buttonEmit)="$event.name === 'add' ? addInitEvent() : removeSelectedInitEvent()"></app-button-bar>
            <table mat-table [dataSource]="initEventsDataSource" class="mat-elevation-z8 matTableMaxSpace" style="width: 100%">
              <ng-container matColumnDef="eventName">
                <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>event</th>
                <td mat-cell class="textAlignLeft" *matCellDef="let element; let i = index">
                  <span style="font-size: 12px">{{ element.$.eventName || '...' }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="eventValue">
                <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>value</th>
                <td mat-cell class="textAlignLeft" *matCellDef="let element; let i = index">
                  <span style="font-size: 12px">{{ element.$.eventValue || '...' }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef style="width: 22px; padding: 0"></th>
                <td mat-cell *matCellDef="let element; let i = index" style="padding: 0; text-align: center">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px; cursor: pointer"
                    [style.color]="selectedInitEventIndex === i ? '#fff' : '#4caf50'" (click)="editInitEvent(i)">edit</mat-icon>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['eventName', 'eventValue', 'edit']"></tr>
              <tr mat-row *matRowDef="let row; let i = index; columns: ['eventName', 'eventValue', 'edit']"
                  [style.background]="selectedInitEventIndex === i ? 'var(--background-default2)' : ''"
                  (click)="selectInitEvent(i)" (dblclick)="editInitEvent(i)"></tr>
            </table>
            @if (!accessConfig?.upd) {
              <div class="only-view"></div>
            }
          </ng-template>
        </mat-expansion-panel>
      }
      <!-- Scripts section hidden - no longer in use -->
    </mat-accordion>
  </ng-template>

  <ng-template #animationTemplate>
    <app-block-animation-group></app-block-animation-group>
  </ng-template>

  <ng-template #effectsTemplate>
    <app-block-effect-group></app-block-effect-group>
  </ng-template>
</div>
</mat-drawer-content>
</mat-drawer-container>

</div>
</mat-drawer>
</mat-drawer-container>
    </div>
</div>

<!-- <mat-accordion [multi]="false">
<mat-expansion-panel #effectsPanel portalHandler>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <fa-icon size="lg" class="faNav" [icon]="faCube"></fa-icon>
      <span class="accordionIcons">{{ 'general.effects' | transloco }}</span>
    </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
    @if (effectsPanel.expanded) {
      <app-video-link style="position: absolute; right: 40px; top: 10px" videoLink="effects"></app-video-link>
    }
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <mat-tab-group [@.disabled]="true" [(selectedIndex)]="selectedEffectIndex" tabGroupDrag #tabGroupAnimation class="mini-tab" mat-stretch-tabs="false" mat-align-tabs="start">
      <div>
        @for (sceneEffect of sceneEffects; track sceneEffect) {
          @if (sceneEffect.name != 'Layout' || selectedSceneItemId != selectedSceneId) {
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="tab-label">
                  <fa-icon size="lg" [icon]="sceneEffect.icon"></fa-icon>
                  {{ sceneEffect.translator | transloco }}
                </div>
              </ng-template>
              <ng-template matTabContent>
                <app-block-effects [effectName]="sceneEffect.name">
                </app-block-effects>
              </ng-template>
            </mat-tab>
          }
        }
      </div>

    </mat-tab-group>
  </ng-template>
  @if (!accessConfig?.upd) {
    <div class="only-view"></div>
  }
</mat-expansion-panel>
<mat-expansion-panel #effectActionsPanel portalHandler>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <fa-icon size="lg" class="faNav" [icon]="faRandom"></fa-icon>
      <span class="accordionIcons">{{ 'general.effectActions' | transloco }}</span>
    </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
    @if (effectActionsPanel.expanded) {
      <app-video-link style="position: absolute; right: 40px; top: 10px" videoLink="effectActions"></app-video-link>
    }

  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <app-block-effect-group (selectAnimation)="onSelectAnimation($event)">
    </app-block-effect-group>
    @if (!accessConfig?.upd) {
      <div class="only-view"></div>
    }
  </ng-template>
</mat-expansion-panel>
</mat-accordion> -->

<!-- Deprecated
@if (isBlockTransition) {
  <mat-tab>
    <ng-template mat-tab-label>
      {{ 'general.transitions' | transloco }}aaa
      <fa-icon size="lg" class="faNav" [icon]="faRandom"></fa-icon>
    </ng-template>
    <app-block-base-transitions></app-block-base-transitions>
  </mat-tab>
}
-->
